// How much of a limit is used, as a thin bar: a person's files of their quota
// (the Files page), everyone's of the total (Admin's Files), a person's
// machine hours of their month (the Machines page, byj-1wv.51.15).

/** The share of a limit past which a person is told to make room (files) and a bar is drawn full. */
export const nearlyFull = 0.9;

/** `used` of 1, past it drawn full; `full`, the bar in the failing colour. */
export function Meter({ label, used, full }: { label: string; used: number; full: boolean }) {
  const share = Math.max(0, Math.min(1, used));
  return (
    <span className="storage-bar" role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(share * 100)}>
      <span className={full ? "full" : ""} style={{ width: `${share * 100}%` }} />
    </span>
  );
}
